export default "__VITE_ASSET__DUnWCyKs__"